
import Vue from "vue";

export default Vue.extend({
  // inheritAttrs: false,
  props: [],
  data() {
      return {}
  },
});
